import { NotifyHelper } from "../../../helpers/toast";
import { objGioCongDongHoatDongDefine } from "../../action-types/gio-cong-dong/IGioCongDongHoatDongActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const gioCongDongHoatDongAction = {
    ...generateActions(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG"),
    ...generateActionForKey(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG",
        "SAVE_SUCCESS", (m: any) => NotifyHelper.Success("Saved")),
    ...generateActionForKey(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG",
        "SAVE_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG",
        "DELETE_SUCCESS", (m: any) => NotifyHelper.Success("Deleted")),
    ...generateActionForKey(objGioCongDongHoatDongDefine, "GIO_CONG_DONG_HOAT_DONG",
        "DELETE_ERROR", (m: any) => NotifyHelper.Error(m))
}
